export const mergeEntities = (state, entities = {}) => {
  if (Object.keys(entities).length === 0) {
    return state;
  }
  const newState = { ...state };
  Object.keys(entities).forEach((key) => {
    newState[+key] = {
      ...state[key],
      ...entities[key],
    };
  });
  return newState;
};
